var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPk({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pakistan",
    transform: "translate(0.001 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_286",
    "data-name": "Group 286",
    transform: "translate(-0.001 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_159",
    "data-name": "Ellipse 159",
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2356",
    "data-name": "Path 2356",
    d: "M0,44.267a14.956,14.956,0,0,0,7.8,13.14V31.127A14.956,14.956,0,0,0,0,44.267Z",
    transform: "translate(0 -29.285)",
    fill: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2357",
    "data-name": "Path 2357",
    d: "M140.719,0a14.893,14.893,0,0,0-7.154,1.819V28.1A14.96,14.96,0,1,0,140.719,0Z",
    transform: "translate(-125.761 0.022)",
    fill: "#496e2d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_287",
    "data-name": "Group 287",
    transform: "translate(12.357 9.779)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2358",
    "data-name": "Path 2358",
    d: "M220.475,174.637a4.228,4.228,0,1,1-3.024-7.619,5.2,5.2,0,1,0,4.357,6.03A4.208,4.208,0,0,1,220.475,174.637Z",
    transform: "translate(-211.477 -166.96)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2359",
    "data-name": "Path 2359",
    d: "M344.166,166.959l1.066,1.149,1.422-.659-.763,1.369,1.066,1.149-1.538-.3-.763,1.369-.187-1.556-1.538-.3,1.422-.659Z",
    transform: "translate(-335.249 -166.959)",
    fill: "#f0f0f0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPk);
export default __webpack_public_path__ + "static/media/PK.d424625c5c24402e7502434b77fed011.svg";
export { ForwardRef as ReactComponent };